import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'rbr-section',
    templateUrl: './section.component.html',
    styleUrl: './section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionComponent {}
